import React from 'react';
import PropTypes from 'prop-types';
import { Button as ButtonComponent } from '@material-ui/core';

const outlinedActive = {
  color: '#00857C',
  borderColor: '#00857C',
};

const Button = ({ children, label, isActive, ...props }) => {
  return (
    <ButtonComponent fullWidth variant="contained" style={isActive ? outlinedActive : {}} {...props}>
      {label || children}
    </ButtonComponent>
  );
};

Button.propTypes = {
  /** The content of the button. label has priority over children. */
  label: PropTypes.node,
  /** The content of the button. */
  children: PropTypes.node,
  /** If true, the button will be disabled. */
  disabled: PropTypes.bool,
  /** The variant to use. */
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  /** If true, the button will looks like active (hovered). */
  isActive: PropTypes.bool,
};

Button.defaultProps = {
  label: null,
  children: '',
};

export default Button;
